import { loginManager } from "@/services/security/login-manager";
import { i18n } from "@/i18n";
import { htmlSanitizer } from "@/services/utilities/html-sanitizer";

class StringManager {
  VALID_BACKGROUND_CLASS = ["warning", "danger", "success", "primary"];

  toCamelCase(str) {
    return str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
  }

  capitalize(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  escapeHtml(str) {
    return String(str ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  gender(alias) {
    let ret = 1;
    const female = [
      "subject",
      "component",
      "help-document",
      "unit",
      "skill-category",
      "category",
      "skill",
      "news",
      "training-course",
      "training",
      "absence",
      "skill-session",
      "document-category",
      "plan-contract",
      "registration-data-version",
      "registration-step",
      "mission",
      "contract-mission",
      "contract-activity",
      "unity",
    ];

    const unique = ["data-agreement"];

    if (female.includes(alias)) {
      ret = 2;
    } else if (unique.includes(alias)) {
      ret = 0;
    }

    return ret;
  }

  processGlobalContent(text) {
    const apiPath = loginManager.getApiPath().slice(0, -4);
    const regLink = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g;
    const regImg = /<img\s+(?:[^>]*?\s+)?src="([^"]*)"/g;

    let newtext = text.replaceAll(regImg, function (match, p1) {
      const addDomain = p1.includes("/uploads/news/editor") && !p1.includes(apiPath);
      return '<img src="' + (addDomain ? apiPath : "") + p1 + '"';
    });

    newtext = newtext.replaceAll(regLink, function (match, p1) {
      const addDomain = p1.includes("/uploads/news/editor") && !p1.includes(apiPath);
      return '<a href="' + (addDomain ? apiPath : "") + p1 + '"';
    });

    // ST143-TI-17771 (§3): processGlobalContent is the natural choke point for news/release-note WYSIWYG bodies
    // (see ReleaseNotesItemBlockComponent.vue, store/news/news.js) — sanitize here in addition to the
    // v-safe-html directive used at the render site, as defense in depth for any future caller.
    return htmlSanitizer.sanitize(newtext, htmlSanitizer.RICH_TEXT_PROFILE);
  }

  formatDigitWithDotToString(value) {
    let str = value.toString();
    return str.replace(",", ".");
  }

  enforceDigit(value, maxDigit) {
    const valueToFormatedString = this.formatDigitWithDotToString(value);

    const parts = valueToFormatedString.split(".");
    if (parts[1] && parts[1].length > maxDigit) {
      value = parseFloat(parts[0] + "." + parts[1].slice(0, maxDigit));
    }
    return value;
  }

  formatCurrency(value, currency = "EUR") {
    if (value == null) return null;

    let cleanValue = value;

    if (typeof cleanValue === "string") {
      cleanValue = cleanValue
        .replace(/\s+/g, "")
        .replace("€", "")
        .replace(/[^\d.,-]/g, "")
        .replace(",", ".");
    }

    cleanValue = Number(cleanValue);

    if (isNaN(cleanValue)) return null;

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(cleanValue);
  }

  globalTranslation(key, alias, area, plural, lowerCase = false, type = "title") {
    const gender = this.gender(alias);
    alias = this.toCamelCase(alias);
    let name = i18n.global.tc(area + "." + alias + ".title", plural);
    if (lowerCase) {
      name = name.toLowerCase();
    }
    return i18n.global.tc("global." + key + "." + type, gender, { name: name });
  }
}

export const stringManager = new StringManager();
